export const isFaultyJiraSearchError = (error: Error) => {
  return error.message.includes('/jiraIssueSearch') && error.message.includes('400 Bad Request');
};
